/* eslint-disable */
import { ASSISTED_USERS_MYSELF } from '@ringcentral-integration/commons/modules/RcVideo';
export default {
  topic: 'Título da reunião',
  date: 'Data',
  startTime: 'Hora',
  duration: 'Duração',
  scheduleFor: 'Agendar em nome de',
  meetingSettings: 'Configurações da reunião',
  meetingSettingsDescription:
    'A atualização dessas configurações será aplicada somente à reunião atual.',
  here: 'aqui',
  [ASSISTED_USERS_MYSELF]: 'Eu mesmo',
  joinBeforeHost: 'Permitir que os participantes entrem antes do organizador',
  enableWaitingRoom: 'Ativar sala de espera',
  waitingRoom: 'Ativar sala de espera para',
  waitingRoomTitle: 'Sala de espera',
  waitingRoomDescription:
    'Mantenha as reuniões privadas até você admitir os participantes.',
  waitingRoomNotCoworker: 'Qualquer pessoa fora da minha empresa',
  waitingRoomGuest: 'Pessoas não conectadas',
  waitingRoomAll: 'Todos',
  enterPassword: 'Inserir senha',
  onlyJoinAfterMe: 'Os participantes só podem entrar depois de mim',
  onlyJoinAfterHost: 'Os participantes só podem entrar depois do organizador',
  allowJoinBeforeHostDescription:
    'Mantém a reunião segura e sem distrações até você entrar.',
  muteAudio: 'Ativar mudo para participantes',
  turnOffCamera: 'Desativar câmera para participantes',
  requirePassword: 'Exigir senha',
  useE2ee: 'Usar criptografia de ponta a ponta',
  e2eeTooltip:
    'As reuniões com criptografia de ponta a ponta são privadas, mas recursos alguns recursos, como entrar pelo telefone, legenda oculta e gravação, não estão disponíveis.',
  setPassword: 'Definir senha *',
  setPasswordNotSymbol: 'Definir senha',
  passwordEmptyError: 'Senha da reunião necessária',
  passwordInvalidError:
    'A senha deve ter de 1 a 10 letras ou números, mas não pode conter símbolos',
  passwordHintText:
    'Sua senha deve ter de 1 a 10 letras ou números e não pode conter símbolos',
  usePersonalMeetingId: 'Usar ID da reunião pessoal',
  usePersonalMeetingIdInstead: 'Usar a reunião pessoal em vez disso',
  usePersonalMeetingName: 'Usar a reunião pessoal:',
  meetingSettingsSecurity: 'Segurança',
  onlyAuthUserJoin: 'Somente usuários autenticados podem entrar',
  signedInUsers: 'Usuários conectados',
  signedInCoWorkers: 'Colegas de trabalho conectados',
  limitScreenSharing:
    'Apenas o organizador e os moderadores podem compartilhar tela',
  lockTooltip: 'Configuração gerenciada pelo administrador da empresa',
  pmiSettingAlert:
    'Essas configurações serão aplicadas a todas as reuniões criadas com o PMI',
  today: 'Hoje',
  scheduleForGuidance:
    'Agendando para outra pessoa?\n1. Certifique-se de que você está no Calendário do Outlook dela.\n2. No menu suspenso, selecione a pessoa para quem você está agendando.\n',
  scheduleForGuidanceMore: 'Ver detalhes',
  changePmiSettings: 'Alterar configurações da reunião pessoal',
  allowToRecording: 'Permitir iniciar e parar a gravação',
  allowTranscribe: 'Permitir iniciar e parar a transcrição',
  everyone: 'Todos',
  onlyHostModerators: 'Somente organizador e moderadores',
  advancedSettings: 'Configurações avançadas',
  whoCanJoin: 'Quem pode entrar?',
  requirePasswordDescription:
    'Os participantes que entrarem pelo link da reunião não precisarão digitar a senha.',
  password: 'Senha:',
  passwordLabel: 'Senha',
  edit: 'Editar',
  changePassword: 'Alterar senha',
  passwordRequired: 'A senha é obrigatória',
  passwordLengthError: 'A senha deve ter de 1 a 10 caracteres',
  passwordFormatError: 'A senha só pode conter letras e números',
  passwordHint:
    'A senha deve ter de 1 a 10 letras e números, mas não pode conter símbolos.',
} as const;

// @key: @#@"topic"@#@ @source: @#@"Meeting title"@#@
// @key: @#@"date"@#@ @source: @#@"Date"@#@
// @key: @#@"startTime"@#@ @source: @#@"Time"@#@
// @key: @#@"duration"@#@ @source: @#@"Duration"@#@
// @key: @#@"scheduleFor"@#@ @source: @#@"Schedule on behalf of"@#@
// @key: @#@"meetingSettings"@#@ @source: @#@"Meeting settings"@#@
// @key: @#@"meetingSettingsDescription"@#@ @source: @#@"Update these settings will apply to current meeting only."@#@
// @key: @#@"here"@#@ @source: @#@"here"@#@
// @key: @#@"ASSISTED_USERS_MYSELF"@#@ @source: @#@"Myself"@#@
// @key: @#@"joinBeforeHost"@#@ @source: @#@"Allow participants to join before host"@#@
// @key: @#@"enableWaitingRoom"@#@ @source: @#@"Enable waiting room"@#@
// @key: @#@"waitingRoom"@#@ @source: @#@"Enable waiting room for"@#@
// @key: @#@"waitingRoomTitle"@#@ @source: @#@"Waiting room"@#@
// @key: @#@"waitingRoomDescription"@#@ @source: @#@"Keep meetings private until you admit participants."@#@
// @key: @#@"waitingRoomNotCoworker"@#@ @source: @#@"Anyone outside my company"@#@
// @key: @#@"waitingRoomGuest"@#@ @source: @#@"Anyone not signed in"@#@
// @key: @#@"waitingRoomAll"@#@ @source: @#@"Everyone"@#@
// @key: @#@"enterPassword"@#@ @source: @#@"Enter Password"@#@
// @key: @#@"onlyJoinAfterMe"@#@ @source: @#@"Participants can only join after me"@#@
// @key: @#@"onlyJoinAfterHost"@#@ @source: @#@"Participants can only join after host"@#@
// @key: @#@"allowJoinBeforeHostDescription"@#@ @source: @#@"Keeps the meeting secure and distraction-free until you join."@#@
// @key: @#@"muteAudio"@#@ @source: @#@"Mute audio for participants"@#@
// @key: @#@"turnOffCamera"@#@ @source: @#@"Turn off camera for participants"@#@
// @key: @#@"requirePassword"@#@ @source: @#@"Require password"@#@
// @key: @#@"useE2ee"@#@ @source: @#@"Use end-to-end encryption"@#@
// @key: @#@"e2eeTooltip"@#@ @source: @#@"End-to-end encrypted meetings are the most private, but features like joining by phone, closed captions, and recording aren't available."@#@
// @key: @#@"setPassword"@#@ @source: @#@"Set password *"@#@
// @key: @#@"setPasswordNotSymbol"@#@ @source: @#@"Set password"@#@
// @key: @#@"passwordEmptyError"@#@ @source: @#@"Meeting password required"@#@
// @key: @#@"passwordInvalidError"@#@ @source: @#@"Your password must be 1-10 letters and numbers long but cannot contain symbols"@#@
// @key: @#@"passwordHintText"@#@ @source: @#@"Your password should be 1-10 letters and numbers long but cannot contain symbols"@#@
// @key: @#@"usePersonalMeetingId"@#@ @source: @#@"Use Personal Meeting ID"@#@
// @key: @#@"usePersonalMeetingIdInstead"@#@ @source: @#@"Use personal meeting instead"@#@
// @key: @#@"usePersonalMeetingName"@#@ @source: @#@"Use personal meeting:"@#@
// @key: @#@"meetingSettingsSecurity"@#@ @source: @#@"Security"@#@
// @key: @#@"onlyAuthUserJoin"@#@ @source: @#@"Only authenticated users can join"@#@
// @key: @#@"signedInUsers"@#@ @source: @#@"Signed in users"@#@
// @key: @#@"signedInCoWorkers"@#@ @source: @#@"Signed in co-workers"@#@
// @key: @#@"limitScreenSharing"@#@ @source: @#@"Only host & moderators can share screen"@#@
// @key: @#@"lockTooltip"@#@ @source: @#@"This setting is managed by your company admin"@#@
// @key: @#@"pmiSettingAlert"@#@ @source: @#@"These settings will apply to all meetings created with PMI"@#@
// @key: @#@"today"@#@ @source: @#@"Today"@#@
// @key: @#@"scheduleForGuidance"@#@ @source: @#@"Scheduling for someone else?\n1. Make sure you're on their Outlook calendar.\n2. From the dropdown, select the person you're scheduling for.\n"@#@
// @key: @#@"scheduleForGuidanceMore"@#@ @source: @#@"Learn details"@#@
// @key: @#@"changePmiSettings"@#@ @source: @#@"Change Personal Meeting settings"@#@
// @key: @#@"allowToRecording"@#@ @source: @#@"Allow to start and stop recording"@#@
// @key: @#@"allowTranscribe"@#@ @source: @#@"Allow to start and stop transcription"@#@
// @key: @#@"everyone"@#@ @source: @#@"Everyone"@#@
// @key: @#@"onlyHostModerators"@#@ @source: @#@"Only host and moderators"@#@
// @key: @#@"advancedSettings"@#@ @source: @#@"Advanced settings"@#@
// @key: @#@"whoCanJoin"@#@ @source: @#@"Who can join?"@#@
// @key: @#@"requirePasswordDescription"@#@ @source: @#@"Participants who join via the meeting link won’t need to enter the password."@#@
// @key: @#@"password"@#@ @source: @#@"Password:"@#@
// @key: @#@"passwordLabel"@#@ @source: @#@"Password"@#@
// @key: @#@"edit"@#@ @source: @#@"Edit"@#@
// @key: @#@"changePassword"@#@ @source: @#@"Change Password"@#@
// @key: @#@"passwordRequired"@#@ @source: @#@"Password is required"@#@
// @key: @#@"passwordLengthError"@#@ @source: @#@"Password must be 1-10 characters long"@#@
// @key: @#@"passwordFormatError"@#@ @source: @#@"Password can only contain letters and numbers"@#@
// @key: @#@"passwordHint"@#@ @source: @#@"Your password should be 1-10 letters and numbers long, but can not contain symbols."@#@
